import defaults from "superagent-defaults";
import prefix from "superagent-prefix";
import intercept from "superagent-intercept";
import { getApiUrl } from "../config/api";
import { getPartnerUrl } from "../config/cabinet";
import AuthService from "./AuthService";
import history from "../../utils/history";
import { notAvailable } from "../utils/urls";

const BASE_PATH = getApiUrl();

const request = defaults()
  // .set("Accept", "application/json")
  .set("X-Requested-With", "XMLHttpRequest")
  .set("X-Client", "front")
  .use(prefix(BASE_PATH))
  .on("request", req => {
    req.set("Authorization", `token ${AuthService.getUserToken()}`);
  })
  .use(
    intercept((err, resp) => {
      if (resp && resp.status == 401) {
        window.location.href = getPartnerUrl("login", "auto");
      } else if (resp && resp.status == 503) {
        history.push(notAvailable());
      }
    })
  );

const ApiService = {
  request(url = "/", params = {}, type = "GET") {
    if (type === "GET") return request.get(url);
    else if (type === "POST") return request.post(url).send(params);
    else if (type === "PUT") return request.put(url).send(params);
    else if (type === "DELETE") return request.del(url);
  }
};

export default ApiService;
